import { render } from "./FormCallBack.vue?vue&type=template&id=0e11ee5e"
import script from "./FormCallBack.vue?vue&type=script&lang=js"
export * from "./FormCallBack.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nikita/Documents/works/novosel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__